module.exports = __webpack_public_path__ + "static/img/card2-8.2109442.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/card2-8.png
// module id = BK8T
// module chunks = 1